import { openDB } from "idb";
import { scoresheetDraftId } from "./scoresheet";

const DATABASE_NAME = "oche-league-mobile";
const DATABASE_VERSION = 1;

const database = () => openDB(DATABASE_NAME, DATABASE_VERSION, {
  upgrade(db) {
    if (!db.objectStoreNames.contains("preferences")) db.createObjectStore("preferences");
    if (!db.objectStoreNames.contains("matchPackages")) db.createObjectStore("matchPackages", { keyPath: "matchId" });
    if (!db.objectStoreNames.contains("matchEvents")) {
      const store = db.createObjectStore("matchEvents", { keyPath: "id" });
      store.createIndex("matchId", "matchId");
      store.createIndex("syncState", "syncState");
    }
    if (!db.objectStoreNames.contains("syncQueue")) {
      const store = db.createObjectStore("syncQueue", { keyPath: "id" });
      store.createIndex("createdAt", "createdAt");
    }
    if (!db.objectStoreNames.contains("drafts")) db.createObjectStore("drafts", { keyPath: "id" });
  }
});

export const offlineStore = {
  async getPreference(key) { return (await database()).get("preferences", key); },
  async setPreference(key, value) { return (await database()).put("preferences", value, key); },
  async removePreference(key) { return (await database()).delete("preferences", key); },
  async saveMatchPackage(value) { return (await database()).put("matchPackages", value); },
  async getMatchPackage(matchId) { return (await database()).get("matchPackages", matchId); },
  async getMatchPackages() { return (await database()).getAll("matchPackages"); },
  async saveEvent(value) { return (await database()).put("matchEvents", value); },
  async getMatchEvents(matchId) { return (await database()).getAllFromIndex("matchEvents", "matchId", matchId); },
  async queue(operation) {
    const queued = {
      id: operation.id || crypto.randomUUID(),
      createdAt: operation.createdAt || new Date().toISOString(),
      attempts: operation.attempts || 0,
      ...operation
    };
    await (await database()).put("syncQueue", queued);
    return queued;
  },
  async getQueue() { return (await database()).getAllFromIndex("syncQueue", "createdAt"); },
  async removeQueued(id) { return (await database()).delete("syncQueue", id); },
  async saveDraft(value) { return (await database()).put("drafts", value); },
  async getDraft(id) { return (await database()).get("drafts", id); },
  async saveScoresheetDraft(matchId, value) {
    return (await database()).put("drafts", { id: scoresheetDraftId(matchId), matchId, ...value });
  },
  async getScoresheetDraft(matchId) { return (await database()).get("drafts", scoresheetDraftId(matchId)); },
  async clearScoresheetDraft(matchId) { return (await database()).delete("drafts", scoresheetDraftId(matchId)); },
  async clearForSignOut() {
    const db = await database();
    const transaction = db.transaction(["preferences", "matchPackages", "matchEvents", "syncQueue", "drafts"], "readwrite");
    await Promise.all([...transaction.objectStoreNames].map(name => transaction.objectStore(name).clear()));
    await transaction.done;
  }
};
